import { retrieveUDFD, retrieveWeatherSTEM, retrieveUDFDHourly, retrieveObsAndAstronomy } from './providers.js';
import { renderNDFDHourly } from './components/hourly.js';
import { renderUDFD } from './components/udfd.js';
import { renderWeatherSTEM } from './components/wxstem.js';
import { renderMETAR } from './components/metar.js';


function displayHourlyPlanner(lat, lon) {
  retrieveUDFDHourly(lat, lon, 24)
    .then(udfdhourly => renderNDFDHourly(udfdhourly))
}

function display7DayForecast(lat, lon) {
  retrieveUDFD(lat, lon, 7)
    .then(udfd => renderUDFD(udfd))
    .catch(error => console.log(error));
}

function displayWeatherSTEM() {
  retrieveWeatherSTEM()
    .then(wxstem => renderWeatherSTEM(wxstem))
    .catch(error => console.log(error));
}

function displayCurrents(lat, lon) {
  retrieveObsAndAstronomy(lat, lon)
    .then(data => renderMETAR(data))
    .catch(error => console.log(error))
}

function displayForecastLocation(location) {
  const forecastLocation = document.getElementById('user-location-mainapp');
  
  if (!forecastLocation) {
    forecastLocation.innerHTML = 'No Location Found';
  } else {
    forecastLocation.innerHTML = location;
  }
}

export function displayWeatherData(lat, lon, location) {
  display7DayForecast(lat, lon);
  displayHourlyPlanner(lat, lon, location);
  displayCurrents(lat, lon)
  displayForecastLocation(location);
}

export function displayForecastOnly(lat, lon, location) {
  display7DayForecast(lat, lon);
  displayHourlyPlanner(lat, lon, location);
  displayForecastLocation(location)
}